import moment from 'moment'
import { replaceAll, setCurrency, setNumberWithPoint } from 'utils/utils'

export const CARD_VOUCHER_COMPARISON = [
    {
        title: 'Total Order Voucher',
        name: 'total_order_voucher',
        isCurrency: false,
    },
    {
        title: 'Total Voucher Amount',
        name: 'total_voucher_amount',
        isCurrency: true,
    },
]

export const TABLE_VOUCHER = {
    name: 'Voucher',
    column: [
        {
            name: 'Kode Voucher',
            key: 'voucher_code',
        },
        {
            name: 'Type Voucher',
            key: 'voucher_type',
            className: 'capitalize',
            render: ({ value }) => <div>{replaceAll(value, '-', ' ')}</div>,
        },
        {
            name: 'Total Order',
            key: 'total_order',
            render: ({ value }) => <div>{value ? setNumberWithPoint(value) : '-'}</div>,
        },
        {
            name: 'Total Potongan Voucher',
            key: 'total_amount',
            render: ({ value }) => <div>{setCurrency(value)}</div>,
        },
    ],
}

export const INITIAL_DATA_FILTER = {
    search: '',
    page: 1,
    limit: 20,
    orderBy: 'order',
    orderType: 'desc',
    startDate: moment().format('YYYY-MM-DD'),
    endDate: moment().format('YYYY-MM-DD'),
}

export const SORT_VOUCHER = [
    {
        label: 'Sort By Total Order Desc',
        key: 'order_desc',
        name: 'sort-voucher',
    },
    {
        label: 'Sort By Total Order Asc',
        key: 'order_asc',
        name: 'sort-voucher',
    },
    {
        label: 'Sort By Amount Discount Desc',
        key: 'total-sales_desc',
        name: 'sort-voucher',
    },
    {
        label: 'Sort By Amount Discount Asc',
        key: 'total-sales_asc',
        name: 'sort-voucher',
    },
]
